

 (function($) {
      $.fn.hoverIntent = function(handlerIn, handlerOut, selector) {
        var cfg = {
          interval: 100,
          sensitivity: 6,
          timeout: 50
        };
        if (typeof handlerIn === "object") {
          cfg = $.extend(cfg, handlerIn)
        } else {
          if ($.isFunction(handlerOut)) {
            cfg = $.extend(cfg, {
              over: handlerIn,
              out: handlerOut,
              selector: selector
            })
          } else {
            cfg = $.extend(cfg, {
              over: handlerIn,
              out: handlerIn,
              selector: handlerOut
            })
          }
        }
        var cX, cY, pX, pY;
        var track = function(ev) {
          cX = ev.pageX;
          cY = ev.pageY
        };
        var compare = function(ev, ob) {
          ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
          if (Math.sqrt((pX - cX) * (pX - cX) + (pY - cY) * (pY - cY)) < cfg.sensitivity) {
            $(ob).off("mousemove.hoverIntent", track);
            ob.hoverIntent_s = true;
            return cfg.over.apply(ob, [ev])
          } else {
            pX = cX;
            pY = cY;
            ob.hoverIntent_t = setTimeout(function() {
              compare(ev, ob)
            }, cfg.interval)
          }
        };
        var delay = function(ev, ob) {
          ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
          ob.hoverIntent_s = false;
          return cfg.out.apply(ob, [ev])
        };
        var handleHover = function(e) {
          var ev = $.extend({}, e);
          var ob = this;
          if (ob.hoverIntent_t) {
            ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t)
          }
          if (e.type === "mouseenter") {
            pX = ev.pageX;
            pY = ev.pageY;
            $(ob).on("mousemove.hoverIntent", track);
            if (!ob.hoverIntent_s) {
              ob.hoverIntent_t = setTimeout(function() {
                compare(ev, ob)
              }, cfg.interval)
            }
          } else {
            $(ob).off("mousemove.hoverIntent", track);
            if (ob.hoverIntent_s) {
              ob.hoverIntent_t = setTimeout(function() {
                delay(ev, ob)
              }, cfg.timeout)
            }
          }
        };
        return this.on({
          "mouseenter.hoverIntent": handleHover,
          "mouseleave.hoverIntent": handleHover
        }, cfg.selector)
      }
    })(jQuery);

// ---------------------------------------------------------------------------
// Image.switchImage
// helps to switch variant images on variant selection
// ---------------------------------------------------------------------------
Shopify.Image = {
  preload: function (images, size) {
    for (var i=0; i < images.length; i++) {
      var image = images[i];

      this.loadImage(this.getSizedImageUrl(image, size));
    }
  },

  loadImage: function (path) {
    new Image().src = path;
  },

  switchImage: function (image, element, callback) {
    if (!image || !element) {
      return;
    }

    var size = this.imageSize(element.src)
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element);
    } else {
      element.src = imageUrl;
    }
  },

  imageSize: function (src) {
    var match = src.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);

    if (match != null) {
      return match[1];
    } else {
      return null;
    }
  },

  getSizedImageUrl: function (src, size) {
    if (size == null) {
      return src;
    }

    if (size == 'master') {
      return this.removeProtocol(src);
    }

    var match  = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    } else {
      return null;
    }
  },

  removeProtocol: function (path) {
    return path.replace(/http(s)?:/, "");
  }
};


/*! @vimeo/player v2.8.1 | (c) 2019 Vimeo | MIT License | https://github.com/vimeo/player.js */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):((e=e||self).Vimeo=e.Vimeo||{},e.Vimeo.Player=t())}(this,function(){"use strict";function r(e,t){for(var n=0;n<t.length;n++){var 0="==e.indexOf(t.toLowerCase())?e:&quot;&quot;.concat(t.toLowerCase()).concat(e.substr(0,1).toUpperCase()).concat(e.substr(1))}function" 2006="" r="t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,&quot;value&quot;in" r&&(r.writable="!0),Object.defineProperty(e,r.key,r)}}var" e="undefined" !="typeof" global&&"[object="" global]"="=={}.toString.call(global);function" i(e,t){return="" s(e){return="" ^(https?:)?\="" \="" ((player|www)\.)?vimeo\.com(?="$|\/)/.test(e)}function" l(){var="" e,t="0<arguments.length&&void" 0!="=arguments[0]?arguments[0]:{},n=t.id,r=t.url,o=n||r;if(!o)throw" new="" Error("An="" id="" or="" url="" must="" be="" passed,="" either="" in="" an="" options="" object="" as="" a="" data-vimeo-id="" data-vimeo-url="" attribute.");if(e="o,!isNaN(parseFloat(e))&&isFinite(e)&&Math.floor(e)==e)return&quot;https://vimeo.com/&quot;.concat(o);if(s(o))return" o.replace("http:","https:");if(n)throw="" TypeError("“".concat(n,"”="" is="" not="" valid="" video="" id."));throw="" TypeError("“".concat(o,"”="" vimeo.com="" url."))}var="" t="void" window&&void="" Error("Sorry,="" the="" Vimeo="" Player="" API="" available="" this="" browser.");var="" o="undefined" window?window:"undefined"!="typeof" global?global:"undefined"!="typeof" self?self:{};!function(e){if(!e.WeakMap){var="" n="Object.prototype.hasOwnProperty,o=function(e,t,n){Object.defineProperty?Object.defineProperty(e,t,{configurable:!0,writable:!0,value:n}):e[t]=n};e.WeakMap=function(){function" e(){if(void="" TypeError("Constructor="" WeakMap="" requires="" 'new'");if(o(this,"_id","_WeakMap"+"_"+t()+"."+t()),0<arguments.length)throw="" TypeError("WeakMap="" iterable="" supported")}function="" r(e,t){if(!i(e)||!n.call(e,"_id"))throw="" TypeError(t+"="" method="" called="" on="" incompatible="" receiver="" "+typeof="" e)}function="" t(){return="" Math.random().toString().substring(2)}return="" o(e.prototype,"delete",function(e){if(r(this,"delete"),!i(e))return!1;var="" e[this._id],!0)}),o(e.prototype,"get",function(e){if(r(this,"get"),i(e)){var="" t&&t[0]="==e?t[1]:void" 0}}),o(e.prototype,"has",function(e){if(r(this,"has"),!i(e))return!1;var="" TypeError("Invalid="" value="" used="" weak="" map="" key");var="" n&&n[0]="==e?n[1]=t:o(e,this._id,[e,t]),this}),o(e,&quot;_polyfill&quot;,!0),e}()}function" i(e){return="" Object(e)="==e}}(&quot;undefined&quot;!=typeof" self?self:"undefined"!="typeof" window?window:o);var="" a,f="(function(e){var" t,n,r;r="function(){var" t,a,n,e="Object.prototype.toString,r=&quot;undefined&quot;!=typeof" setImmediate?function(e){return="" setImmediate(e)}:setTimeout;try{Object.defineProperty({},"x",{}),t="function(e,t,n,r){return" Object.defineProperty(e,t,{value:n,writable:!0,configurable:!1!="=r})}}catch(e){t=function(e,t,n){return" e[t]="n,e}}function" i(e,t){n.add(e,t),a||(a="r(n.drain))}function" u(e){var="" t,n="typeof" e;return="" null="=e||&quot;object&quot;!=n&&&quot;function&quot;!=n||(t=e.then),&quot;function&quot;==typeof" t&&t}function="" c(){for(var="" o(e,t,n){var="" r,o;try{!1="==t?n.reject(e.msg):(r=!0===t?e.msg:t.call(void" 0,e.msg))="==n.promise?n.reject(TypeError(&quot;Promise-chain" cycle")):(o="u(r))?o.call(r,n.resolve,n.reject):n.resolve(r)}catch(e){n.reject(e)}}function" s(e){var="" l(e,n,r,o){for(var="" f(e){this.def="e,this.triggered=!1}function" d(e){this.promise="e,this.state=0,this.triggered=!1,this.chain=[],this.msg=void" 0}function="" h(e){if("function"!="typeof" e)throw="" TypeError("Not="" function");if(0!="=this.__NPO__)throw" promise");this.__NPO__="1;var" d(this);this.then="function(e,t){var" e||e,failure:"function"="=typeof" t&&t};return="" n.promise="new" this.constructor(function(e,t){if("function"!="typeof" e||"function"!="typeof" t)throw="" function");n.resolve="e,n.reject=t}),r.chain.push(n),0!==r.state&&i(c,r),n.promise},this.catch=function(e){return" this.then(void="" 0,e)};try{e.call(void="" 0,function(e){(function="" e(n){var="" r,o="this;if(!o.triggered){o.triggered=!0,o.def&&(o=o.def);try{(r=u(n))?i(function(){var" f(o);try{r.call(n,function(){e.apply(t,arguments)},function(){s.apply(t,arguments)})}catch(e){s.call(t,e)}}):(o.msg="n,o.state=1,0<o.chain.length&&i(c,o))}catch(e){s.call(new" f(o),e)}}}).call(r,e)},function(e){s.call(r,e)})}catch(e){s.call(r,e)}}n="function(){var" n,r,o;function="" i(e,t){this.fn="e,this.self=t,this.next=void" 0}return{add:function(e,t){o="new" i(e,t),r?r.next="o:n=o,r=o,o=void" 0},drain:function(){var="" 0;e;)e.fn.call(e.self),e="e.next}}}();var" v="t({},&quot;constructor&quot;,h,!1);return" t(h.prototype="v,&quot;__NPO__&quot;,0,!1),t(h,&quot;resolve&quot;,function(n){return" n&&"object"="=typeof" n&&1="==n.__NPO__?n:new" this(function(e,t){if("function"!="typeof" function");e(n)})}),t(h,"reject",function(n){return="" function");t(n)})}),t(h,"all",function(t){var="" Array]"!="e.call(t)?a.reject(TypeError(&quot;Not" array")):0="==t.length?a.resolve([]):new" a(function(n,e){if("function"!="typeof" n||"function"!="typeof" function");var="" array")):new="" r(function(n,e){if("function"!="typeof" function");l(r,t,function(e,t){n(t)},e)})}),h},(n="o)[t=&quot;Promise&quot;]=n[t]||r(),e.exports&&(e.exports=n[t])}(a={exports:{}},a.exports),a.exports),d=new" WeakMap;function="" u(e,t,n){var="" r||(r[t]="[]),r[t].push(n),d.set(e.element,r)}function" c(e,t){return(d.get(e.element)||{})[t]||[]}function="" h(e,t,n){var="" r[t]="[],d.set(e.element,r),!0;var" p(r){var="" v.reduce(function(e,t){var="" y(e,t){var="" TypeError("An="" element="" provided");if(null!="=t.getAttribute(&quot;data-vimeo-initialized&quot;))return" t.querySelector("iframe");var="" r.innerHTML="n,t.appendChild(r.firstChild),t.setAttribute(&quot;data-vimeo-initialized&quot;,&quot;true&quot;),t.querySelector(&quot;iframe&quot;)}function" m(i){var="" 0;return="" Promise(function(t,n){if(!s(i))throw="" TypeError("“".concat(i,"”="" url."));var="" .concat(encodeURIComponent(i),"&domain=").concat(window.location.hostname);for(var r in a)a.hasOwnProperty(r)&&(e+=" &".concat(r,"=").concat(encodeURIComponent(a[r])));var o=" XDomainRequest"in="" window?new="" XDomainRequest:new="" XMLHttpRequest;o.open("GET",e,!0),o.onload="function(){if(404!==o.status)if(403!==o.status)try{var" y(e,u),void="" n(new="" Error("“".concat(i,"”="" embeddable.")));t(e)}catch(e){n(e)}else="" embeddable.")));else="" was="" found.")))},o.onerror="function(){var" (".concat(o.status,")"):"";n(new="" Error("There="" error="" fetching="" embed="" code="" from="" Vimeo".concat(e,".")))},o.send()})}function="" g(e){if("string"="=typeof" e)try{e="JSON.parse(e)}catch(e){return" console.warn(e),{}}return="" e}function="" w(e,t,n){if(e.element.contentWindow&&e.element.contentWindow.postMessage){var="" (\d+).*$="" ,"$1"));8<="o&&o<10&&(r=JSON.stringify(r)),e.element.contentWindow.postMessage(r,e.origin)}}function" b(n,r){var="" t,e="[];if((r=g(r)).event){if(&quot;error&quot;===r.event)c(n,r.data.method).forEach(function(e){var" Error(r.data.message);t.name="r.data.name,e.reject(t),h(n,r.data.method,e)});e=c(n,&quot;event:&quot;.concat(r.event)),t=r.data}else" if(r.method){var="" h(e,t,r),r}(n,r.method);o&&(e.push(o),t="r.value)}e.forEach(function(e){try{if(&quot;function&quot;==typeof" e)return="" void="" e.call(n,t);e.resolve(t)}catch(e){}})}var="" k="new" WeakMap,E="new" WeakMap,Player="function(){function" Player(u){var="" e,c="this,n=1<arguments.length&&void" instanceof="" t))throw="" TypeError("Cannot="" call="" class="" function")}(this,Player),window.jQuery&&u="" jQuery&&(1<u.length&&window.console&&console.warn&&console.warn("A="" jQuery="" with="" multiple="" elements="" using="" first="" element."),u="u[0]),&quot;undefined&quot;!=typeof" document&&"string"="=typeof" u&&(u="document.getElementById(u)),e=u,!Boolean(e&&1===e.nodeType&&&quot;nodeName&quot;in" e&&e.ownerDocument&&e.ownerDocument.defaultView))throw="" TypeError("You="" pass="" id.");var="" Error("The="" player="" passed="" isn’t="" embed.");if(k.has(u))return="" k.get(u);this.element="u,this.origin=&quot;*&quot;;var" f(function(i,a){var="" Error(t.data.message);return="" n.name="t.data.name,void" a(n)}var="" c.element.setAttribute("data-ready","true"),void="" i();b(c,t)}};if(r.addEventListener?r.addEventListener("message",e,!1):r.attachEvent&&r.attachEvent("onmessage",e),"IFRAME"!="=c.element.nodeName){var" t,n,r,o="y(e,u);return" c.element="o,c._originalElement=u,t=u,n=o,r=d.get(t),d.set(n,r),d.delete(t),k.set(c.element,c),e}).catch(a)}});return" E.set(this,o),k.set(this.element,this),"IFRAME"="==this.element.nodeName&&w(this,&quot;ping&quot;),this}var" e,t,n;return="" f(function(e,t){return="" r.ready().then(function(){u(r,n,{resolve:e,reject:t}),w(r,n,o)}).catch(t)})}},{key:"get",value:function(n){var="" f(function(e,t){if(n="i(n,&quot;set&quot;),null==r)throw" TypeError("There="" to="" set.");return="" o.ready().then(function(){u(o,n,{resolve:e,reject:t}),w(o,n,r)}).catch(t)})}},{key:"on",value:function(e,t){if(!e)throw="" event="" name.");if(!t)throw="" callback="" function.");if("function"!="typeof" TypeError("The="" function.");0="==c(this,&quot;event:&quot;.concat(e)).length&&this.callMethod(&quot;addEventListener&quot;,e).catch(function(){}),u(this,&quot;event:&quot;.concat(e),t)}},{key:&quot;off&quot;,value:function(e,t){if(!e)throw" name.");if(t&&"function"!="typeof" function.");h(this,"event:".concat(e),t)&&this.callMethod("removeEventListener",e).catch(function(e){})}},{key:"loadVideo",value:function(e){return="" this.callMethod("loadVideo",e)}},{key:"ready",value:function(){var="" f(function(e,t){t(new="" Error("Unknown="" player.="" Probably="" unloaded."))});return="" f.resolve(e)}},{key:"addCuePoint",value:function(e){var="" this.callMethod("addCuePoint",{time:e,data:t})}},{key:"removeCuePoint",value:function(e){return="" this.callMethod("removeCuePoint",e)}},{key:"enableTextTrack",value:function(e,t){if(!e)throw="" language.");return="" this.callMethod("enableTextTrack",{language:e,kind:t})}},{key:"disableTextTrack",value:function(){return="" this.callMethod("disableTextTrack")}},{key:"pause",value:function(){return="" this.callMethod("pause")}},{key:"play",value:function(){return="" this.callMethod("play")}},{key:"unload",value:function(){return="" this.callMethod("unload")}},{key:"destroy",value:function(){var="" f(function(e){E.delete(t),k.delete(t.element),t._originalElement&&(k.delete(t._originalElement),t._originalElement.removeAttribute("data-vimeo-initialized")),t.element&&"IFRAME"="==t.element.nodeName&&t.element.parentNode&&t.element.parentNode.removeChild(t.element),e()})}},{key:&quot;getAutopause&quot;,value:function(){return" this.get("autopause")}},{key:"setAutopause",value:function(e){return="" this.set("autopause",e)}},{key:"getBuffered",value:function(){return="" this.get("buffered")}},{key:"getColor",value:function(){return="" this.get("color")}},{key:"setColor",value:function(e){return="" this.set("color",e)}},{key:"getCuePoints",value:function(){return="" this.get("cuePoints")}},{key:"getCurrentTime",value:function(){return="" this.get("currentTime")}},{key:"setCurrentTime",value:function(e){return="" this.set("currentTime",e)}},{key:"getDuration",value:function(){return="" this.get("duration")}},{key:"getEnded",value:function(){return="" this.get("ended")}},{key:"getLoop",value:function(){return="" this.get("loop")}},{key:"setLoop",value:function(e){return="" this.set("loop",e)}},{key:"getPaused",value:function(){return="" this.get("paused")}},{key:"getPlaybackRate",value:function(){return="" this.get("playbackRate")}},{key:"setPlaybackRate",value:function(e){return="" this.set("playbackRate",e)}},{key:"getPlayed",value:function(){return="" this.get("played")}},{key:"getSeekable",value:function(){return="" this.get("seekable")}},{key:"getSeeking",value:function(){return="" this.get("seeking")}},{key:"getTextTracks",value:function(){return="" this.get("textTracks")}},{key:"getVideoEmbedCode",value:function(){return="" this.get("videoEmbedCode")}},{key:"getVideoId",value:function(){return="" this.get("videoId")}},{key:"getVideoTitle",value:function(){return="" this.get("videoTitle")}},{key:"getVideoWidth",value:function(){return="" this.get("videoWidth")}},{key:"getVideoHeight",value:function(){return="" this.get("videoHeight")}},{key:"getVideoUrl",value:function(){return="" this.get("videoUrl")}},{key:"getVolume",value:function(){return="" this.get("volume")}},{key:"setVolume",value:function(e){return="" this.set("volume",e)}}])&&r(e.prototype,t),n&&r(e,n),Player}();return="" e||(function(){var="" [data-vimeo-url]")),n="function(e){&quot;console&quot;in" window&&console.error&&console.error("There="" creating="" embed:="" ".concat(e))};t.forEach(function(t){try{if(null!="=t.getAttribute(&quot;data-vimeo-defer&quot;))return;var" y(e,t)}).catch(n)}catch(e){n(e)}})}(),function(){var="" *="" Cookie="" plugin="" Copyright="" (c)="" Klaus="" Hartl="" (stilbuero.de)="" Dual="" licensed="" under="" MIT="" and="" GPL="" licenses:="" http:="" www.opensource.org="" licenses="" mit-license.php="" www.gnu.org="" gpl.html="" jQuery.cookie="function(b,j,m){if(typeof" j!="undefined" ){m="m||{};if(j===null){j=&quot;&quot;;m.expires=-1}var" ;if(m.expires&&(typeof="" m.expires="=&quot;number&quot;||m.expires.toUTCString)){var" f;if(typeof="" Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f="m.expires}e=&quot;;" expires="+f.toUTCString()}var l=m.path?" ;="" path="+(m.path):" ";var="" g="m.domain?&quot;;" domain="+(m.domain):" secure":"";document.cookie="[b,&quot;=&quot;,encodeURIComponent(j),e,l,g,a].join(&quot;&quot;)}else{var" d="null;if(document.cookie&&document.cookie!=&quot;&quot;){var" h="0;h<k.length;h++){var" c="jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+&quot;=&quot;)){d=decodeURIComponent(c.substring(b.length+1));break}}}return" d}};="" **="" jquery-match-height="" master="" by="" @liabru="" brm.io="" License:="" ;(function(factory)="" {="" eslint-disable-line="" no-extra-semi="" 'use="" strict';="" if="" (typeof="" define="==" 'function'="" &&="" define.amd)="" AMD="" define(['jquery'],="" factory);="" }="" else="" module="" 'undefined'="" module.exports)="" CommonJS="" module.exports="factory(require('jquery'));" Global="" factory(jQuery);="" })(function($)="" internal="" var="" _previousResizeWidth="-1," _updateTimeout="-1;" _parse="" parse="" utility="" function="" convert="" NaN="" return="" parseFloat(value)="" ||="" 0;="" };="" _rows="" returns="" array="" of="" selections="" representing="" each="" row="" (as="" displayed="" after="" float="" wrapping="" applied="" browser)="" tolerance="1," $elements="$(elements)," lastTop="null," rows="[];" group="" their="" top="" position="" $elements.each(function(){="" $that="$(this)," -="" _parse($that.css('margin-top')),="" lastRow="rows.length"> 0 ? rows[rows.length - 1] : null;

      if (lastRow === null) {
        // first item on the row, so just push it
        rows.push($that);
      } else {
        // if the row top is the same, add to the row group
        if (Math.floor(Math.abs(lastTop - top)) <= tolerance) {
          rows[rows.length - 1] = lastRow.add($that);
        } else {
          // otherwise start a new row group
          rows.push($that);
        }
      }

      // keep track of the last row top
      lastTop = top;
    });

    return rows;
  };

  /*
    *  _parseOptions
    *  handle plugin options
    */

  var _parseOptions = function(options) {
    var opts = {
      byRow: true,
      property: 'height',
      target: null,
      remove: false
    };

    if (typeof options === 'object') {
      return $.extend(opts, options);
    }

    if (typeof options === 'boolean') {
      opts.byRow = options;
    } else if (options === 'remove') {
      opts.remove = true;
    }

    return opts;
  };

  /*
    *  matchHeight
    *  plugin definition
    */

  var matchHeight = $.fn.matchHeight = function(options) {
    var opts = _parseOptions(options);

    // handle remove
    if (opts.remove) {
      var that = this;

      // remove fixed height from all selected elements
      this.css(opts.property, '');

      // remove selected elements from all groups
      $.each(matchHeight._groups, function(key, group) {
        group.elements = group.elements.not(that);
      });

      // TODO: cleanup empty groups

      return this;
    }

    if (this.length <= 1 && !opts.target) {
      return this;
    }

    // keep track of this group so we can re-apply later on load and resize events
    matchHeight._groups.push({
      elements: this,
      options: opts
    });

    // match each element's height to the tallest element in the selection
    matchHeight._apply(this, opts);

    return this;
  };

  /*
    *  plugin global options
    */

  matchHeight.version = 'master';
  matchHeight._groups = [];
  matchHeight._throttle = 80;
  matchHeight._maintainScroll = true;
  matchHeight._beforeUpdate = null;
  matchHeight._afterUpdate = null;
  matchHeight._rows = _rows;
  matchHeight._parse = _parse;
  matchHeight._parseOptions = _parseOptions;

  /*
    *  matchHeight._apply
    *  apply matchHeight to given elements
    */

  matchHeight._apply = function(elements, options) {
    var opts = _parseOptions(options),
        $elements = $(elements),
        rows = [$elements];

    // take note of scroll position
    var scrollTop = $(window).scrollTop(),
        htmlHeight = $('html').outerHeight(true);

    // get hidden parents
    var $hiddenParents = $elements.parents().filter(':hidden');

    // cache the original inline style
    $hiddenParents.each(function() {
      var $that = $(this);
      $that.data('style-cache', $that.attr('style'));
    });

    // temporarily must force hidden parents visible
    $hiddenParents.css('display', 'block');

    // get rows if using byRow, otherwise assume one row
    if (opts.byRow && !opts.target) {

      // must first force an arbitrary equal height so floating elements break evenly
      $elements.each(function() {
        var $that = $(this),
            display = $that.css('display');

        // temporarily force a usable display value
        if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
          display = 'block';
        }

        // cache the original inline style
        $that.data('style-cache', $that.attr('style'));

        $that.css({
          'display': display,
          'padding-top': '0',
          'padding-bottom': '0',
          'margin-top': '0',
          'margin-bottom': '0',
          'border-top-width': '0',
          'border-bottom-width': '0',
          'height': '100px',
          'overflow': 'hidden'
        });
      });

      // get the array of rows (based on element top position)
      rows = _rows($elements);

      // revert original inline styles
      $elements.each(function() {
        var $that = $(this);
        $that.attr('style', $that.data('style-cache') || '');
      });
    }

    $.each(rows, function(key, row) {
      var $row = $(row),
          targetHeight = 0;

      if (!opts.target) {
        // skip apply to rows with only one item
        if (opts.byRow && $row.length <= 1) {
          $row.css(opts.property, '');
          return;
        }

        // iterate the row and find the max height
        $row.each(function(){
          var $that = $(this),
              style = $that.attr('style'),
              display = $that.css('display');

          // temporarily force a usable display value
          if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
            display = 'block';
          }

          // ensure we get the correct actual height (and not a previously set height value)
          var css = { 'display': display };
          css[opts.property] = '';
          $that.css(css);

          // find the max height (including padding, but not margin)
          if ($that.outerHeight(false) > targetHeight) {
            targetHeight = $that.outerHeight(false);
          }

          // revert styles
          if (style) {
            $that.attr('style', style);
          } else {
            $that.css('display', '');
          }
        });
      } else {
        // if target set, use the height of the target element
        targetHeight = opts.target.outerHeight(false);
      }

      // iterate the row and apply the height to all elements
      $row.each(function(){
        var $that = $(this),
            verticalPadding = 0;

        // don't apply to a target
        if (opts.target && $that.is(opts.target)) {
          return;
        }

        // handle padding and border correctly (required when not using border-box)
        if ($that.css('box-sizing') !== 'border-box') {
          verticalPadding += _parse($that.css('border-top-width')) + _parse($that.css('border-bottom-width'));
          verticalPadding += _parse($that.css('padding-top')) + _parse($that.css('padding-bottom'));
        }

        // set the height (accounting for padding and border)
        $that.css(opts.property, (targetHeight - verticalPadding) + 'px');
      });
    });

    // revert hidden parents
    $hiddenParents.each(function() {
      var $that = $(this);
      $that.attr('style', $that.data('style-cache') || null);
    });

    // restore scroll position if enabled
    if (matchHeight._maintainScroll) {
      $(window).scrollTop((scrollTop / htmlHeight) * $('html').outerHeight(true));
    }

    return this;
  };

  /*
    *  matchHeight._applyDataApi
    *  applies matchHeight to all elements with a data-match-height attribute
    */

  matchHeight._applyDataApi = function() {
    var groups = {};

    // generate groups by their groupId set by elements using data-match-height
    $('[data-match-height], [data-mh]').each(function() {
      var $this = $(this),
          groupId = $this.attr('data-mh') || $this.attr('data-match-height');

      if (groupId in groups) {
        groups[groupId] = groups[groupId].add($this);
      } else {
        groups[groupId] = $this;
      }
    });

    // apply matchHeight to each group
    $.each(groups, function() {
      this.matchHeight(true);
    });
  };

  /*
    *  matchHeight._update
    *  updates matchHeight on all current groups with their correct options
    */

   var _update = function(event) {
    if (matchHeight._beforeUpdate) {
      matchHeight._beforeUpdate(event, matchHeight._groups);
    }

    $.each(matchHeight._groups, function(index ) {
      var thisElement = this;
      var timerVal = 0;

      if(thisElement.elements.length){
         timerVal += 500;
        setTimeout(function () {
           matchHeight._apply(thisElement.elements, thisElement.options);
      }, timerVal);
    }
    });

    if (matchHeight._afterUpdate) {
      matchHeight._afterUpdate(event, matchHeight._groups);
    }
  };

  matchHeight._update = function(throttle, event) {
    // prevent update if fired from a resize event
    // where the viewport width hasn't actually changed
    // fixes an event looping bug in IE8
    if (event && event.type === 'resize') {
      var windowWidth = $(window).width();
      if (windowWidth === _previousResizeWidth) {
        return;
      }
      _previousResizeWidth = windowWidth;
    }

    // throttle updates
    if (!throttle) {
      _update(event);
    } else if (_updateTimeout === -1) {
      _updateTimeout = setTimeout(function() {
        _update(event);
        _updateTimeout = -1;
      }, matchHeight._throttle);
    }
  };

  /*
    *  bind events
    */

  // apply on DOM ready event
  $(matchHeight._applyDataApi);

  // update heights on load and resize events
  $(window).bind('load', function(event) {
    matchHeight._update(false, event);
  });

  // throttled update heights on resize events
  $(window).bind('resize orientationchange', function(event) {
    matchHeight._update(true, event);
  });

});


 /*
  * YoutubeBackground - A wrapper for the Youtube API - Great for fullscreen background videos or just regular videos.
  *
  * Licensed under the MIT license:
  *   http://www.opensource.org/licenses/mit-license.php
  *
  *
  * Version:  1.0.5
  *
  */
"function"!=typeof Object.create&&(Object.create=function(e){function t(){}return t.prototype=e,new t}),function(e,t,o){var a=function(o){"undefined"==typeof YT&&void 0===t.loadingPlayer?(t.loadingPlayer=!0,t.dfd=e.Deferred(),t.onYouTubeIframeAPIReady=function(){t.onYouTubeIframeAPIReady=null,t.dfd.resolve("done"),o()}):"object"==typeof YT?o():t.dfd.done(function(e){o()})};YTPlayer={player:null,defaults:{ratio:16/9,videoId:"LSmgKRx5pBo",mute:!0,repeat:!0,width:e(t).width(),playButtonClass:"YTPlayer-play",pauseButtonClass:"YTPlayer-pause",muteButtonClass:"YTPlayer-mute",volumeUpClass:"YTPlayer-volume-up",volumeDownClass:"YTPlayer-volume-down",start:0,pauseOnScroll:!1,fitToBackground:!0,playerVars:{iv_load_policy:3,modestbranding:1,autoplay:1,controls:0,showinfo:0,wmode:"opaque",branding:0,autohide:0},events:null},init:function(n,i){var l,r,d,s=this;return s.userOptions=i,s.$body=e("body"),s.$node=e(n),s.$window=e(t),s.defaults.events={onReady:function(e){s.onPlayerReady(e),s.options.pauseOnScroll&&s.pauseOnScroll(),"function"==typeof s.options.callback&&s.options.callback.call(this)},onStateChange:function(e){1===e.data?(s.$node.find("img").fadeOut(400),s.$node.addClass("loaded")):0===e.data&&s.options.repeat&&s.player.seekTo(s.options.start)}},s.options=e.extend(!0,{},s.defaults,s.userOptions),s.options.height=Math.ceil(s.options.width/s.options.ratio),s.ID=(new Date).getTime(),s.holderID="YTPlayer-ID-"+s.ID,s.options.fitToBackground?s.createBackgroundVideo():s.createContainerVideo(),s.$window.on("resize.YTplayer"+s.ID,function(){s.resize(s)}),l=s.onYouTubeIframeAPIReady.bind(s),r=o.createElement("script"), r.id="youtube-sdk",d=o.getElementsByTagName("head")[0],"file://"==t.location.origin?r.src="http://www.youtube.com/iframe_api":r.src="//www.youtube.com/iframe_api",d.appendChild(r),console.log(r),d=null,r=null,a(l),s.resize(s),s},pauseOnScroll:function(){var e=this;e.$window.on("scroll.YTplayer"+e.ID,function(){1===e.player.getPlayerState()&&e.player.pauseVideo()}),e.$window.scrollStopped(function(){2===e.player.getPlayerState()&&e.player.playVideo()})},createContainerVideo:function(){var t=this,o=e('<div id="ytplayer-container'+t.ID+'">                                    <div id="'+t.holderID+'" class="ytplayer-player-inline"></div>                                     </div>                                     <div id="ytplayer-shield" class="ytplayer-shield"></div>');t.$node.append(o),t.$YTPlayerString=o,o=null},createBackgroundVideo:function(){var t=this,o=e('<div id="ytplayer-container'+t.ID+'" class="ytplayer-container background">                                    <div id="'+t.holderID+'" class="ytplayer-player"></div>                                    </div>                                    <div id="ytplayer-shield" class="ytplayer-shield"></div>');t.$node.append(o),t.$YTPlayerString=o,o=null},resize:function(o){var a=e(t);o.options.fitToBackground||(a=o.$node);var n,i,l=a.width(),r=a.height(),d=e("#"+o.holderID);l/o.options.ratio<r?(n=math.ceil(r*o.options.ratio),d.width(n).height(r).css({left:(l-n) 2,top:0})):(i="Math.ceil(l/o.options.ratio),d.width(l).height(i).css({left:0,top:(r-i)/2})),d=null,a=null},onYouTubeIframeAPIReady:function(){theme.ProductVideo.youtubeApiLoaded" =="" true;="" theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube);="" var="" e="this;e.player=new" t.YT.Player(e.holderID,e.options)},onPlayerReady:function(e){this.options.mute&&e.target.mute()},getPlayer:function(){return="" this.player},destroy:function(){var="" o="this;o.$node.removeData(&quot;yt-init&quot;).removeData(&quot;ytPlayer&quot;).removeClass(&quot;loaded&quot;),o.$YTPlayerString.remove(),e(t).off(&quot;resize.YTplayer&quot;+o.ID),e(t).off(&quot;scroll.YTplayer&quot;+o.ID),o.$body=null,o.$node=null,o.$YTPlayerString=null,o.player.destroy(),o.player=null}},e.fn.scrollStopped=function(t){var" this.each(function(){var="" a="Object.create(YTPlayer);a.init(o,t),e.data(o,&quot;ytPlayer&quot;,a)})}}(jQuery,window,document);" *!="" Pushy="" -="" v0.9.2="" 2014-9-13="" *="" is="" responsive="" off-canvas="" navigation="" menu="" using="" CSS="" transforms="" &="" transitions.="" https:="" github.com="" christophery="" pushy="" by="" Christopher="" Yee="" initPushyMenu="function()" {="" nav="$('#pushy-menu')," css="" class="" navBtn="$('.pushy-menu-btn')," filters="$('#pushy-filters')," filtersBnt="$('#pushy-filters-btn')," body="$('body,html')," container="$('#container," .notification-bar,="" .nav-main-logo,="" .nav-container-float'),="" filterContainer="$('.container-pushy-main," .page-header,="" #shopify-section-footer,="" .nav-standard,="" push="$('.push')," to="" add="" capability="" siteOverlay="$('.site-overlay')," site="" overlay="" pushyActiveClass="pushy-active" ,="" toggle="" containerClass="container-push" open="" pushClass="push-push" menuSpeed="200," jQuery="" fallback="" speed="" navState="true," closeNav="$('#pushy-close," .mobile-menu-close-icon'),="" closeFilters="$('#pushy-close-filters," filtersState="true," mp="$.magnificPopup.instance;" function="" openPushyNav()="" if(!filtersState)="" closePushyFilters();="" }="" $(".left_nav_icons_accordion").addClass("nav_icons_accordion_open");="" nav.addClass("pushy-open");="" body.addClass(pushyActiveClass);="" container.addClass(containerClass);="" push.addClass(pushClass);="" navBtn.addClass('tcon-transform');="" mp.close();="" $('a,="" button,="" input,="" select,="" textarea,="" object,="" area,="" iframe').each(function(index,="" el){="" if="" ($(el).attr('tabindex')="" !="-1" )="" $(el).attr('tabindex',="" '-2');="" });="" $('.header-nav-pushy="" a,="" .header-nav-pushy="" button').each(function(index,="" 0);="" $('.left_nav_icons_accordion="" .left_nav_icons_accordion="" closePushyNav()="" nav.removeClass("pushy-open");="" $(".left_nav_icons_accordion").removeClass("nav_icons_accordion_open");="" body.removeClass(pushyActiveClass);="" container.removeClass(containerClass);="" push.removeClass(pushClass);="" navBtn.removeClass('tcon-transform')="" -1);="" select').each(function(index,="" $('[tabindex]').each(function(index,="" '-2')="" '0');="" ($('.minimal-top-nav').length=""> 0) {
      setTimeout(function(){
        $('.nav-container-actions > li:eq(0)').children().focus();
      },10);
    }
  }

  function openPushyFilters()
  {
    if(!navState) {
      closePushyNav();
      navState = true;
    }
    filters.addClass("pushy-open");
    body.addClass(pushyActiveClass);
    filterContainer.addClass(containerClass);
    push.addClass(pushClass);
    mp.close();
  }

  function closePushyFilters() {
    filters.removeClass("pushy-open");
    body.removeClass(pushyActiveClass);
    filterContainer.removeClass(containerClass);
    push.removeClass(pushClass);
  }

  navBtn.on('click', function(e) {
    e.preventDefault();
    if (navState) {
      openPushyNav();
      navState = false;
    } else {
      closePushyNav();
      navState = true;
    }
  });

  closeNav.on('click', function(e) {
    e.preventDefault();
    closePushyNav();
    navState = true;
  });

  closeFilters.on('click', function(e) {
    e.preventDefault();
    closePushyFilters();
    filtersState = true;
  });

  filtersBnt.on('click', function(e) {
    e.preventDefault();
    if (filtersState) {
      openPushyFilters();
      filtersState = false;
    } else {
      closePushyFilters();
      filtersState = true;
    }
  });

  siteOverlay.on('click', function(){
    closePushyNav();
    navState = true;
    closePushyFilters();
    filtersState = true;
  });


  return {
    close: function() {
      return closePushyFilters();
    }
  }
};

function inlineSwiper($container) {
  var id = $container.attr('data-section-id');
  var blocksPerView = +$container.attr('data-blocks-per-view');
  var blocksMax = +$container.attr('data-blocks-limit');
  var blocksCount = +$container.attr('data-blocks-count');
  var blockAutoplay = +$container.attr('data-autoplay') * 1000;
  var setAutoplay = blockAutoplay ? {delay: blockAutoplay} : false;
  var mobileSlides = +$container.attr('data-mobile-items') || 1;
  var spaceBetweenBlocks;

  switch (blocksPerView) {
    case 2:
      spaceBetweenBlocks = 30;
      break;
    case 3:
      spaceBetweenBlocks = 25;
      break;
    case 4:
      spaceBetweenBlocks = 15;
      break;
    case 5 || 6:
      spaceBetweenBlocks = 10;
      break;
    default:
      spaceBetweenBlocks = 15;
  }

  return new Swiper ('#inline-swiper-'+id, {
    direction: 'horizontal',
     pagination: {
        el: '#swiper-pagination-'+id,
        clickable: true
      },
      loop: !!blockAutoplay,
      slidesPerView: mobileSlides,
      slidesPerGroup: 1,
      spaceBetween: spaceBetweenBlocks,
      // simulateTouch: ($(window).width() <= 768) || (blocksPerView < blocksMax && blocksPerView < blocksCount),
      simulateTouch: true,
      breakpoints: {
        768: {
          slidesPerView: blocksPerView,
          slidesPerGroup: 1,
          spaceBetween: 15
        }
      },
      autoplay: setAutoplay
    });
}


window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
  .on('shopify:section:load', this._onSectionLoad.bind(this))
  .on('shopify:section:unload', this._onSectionUnload.bind(this))
  .on('shopify:section:select', this._onSelect.bind(this))
  .on('shopify:section:deselect', this._onDeselect.bind(this))
  .on('shopify:section:reorder', this._onReorder.bind(this))
  .on('shopify:block:select', this._onBlockSelect.bind(this))
  .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },
  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.originalEvent.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {

    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },
  _onReorder: function(evt) {
    var isSlideshow = $("#container").find(".shopify-section").first().hasClass("home-slideshow-section");
    var isOverlap = $("#top-header-section").data("index-overlap"),
        bgColor = $("#top-header-section").data("bg-color"),
        imgWidth = $("#top-header-section").data("logo-width")+"px";
    if(isSlideshow && isOverlap){
       $(".nav-standard-float, .nav-container, .nav-main-logo").css({"position":"absolute", "background": "none"});
       $(".nav-main-logo img").css("width", imgWidth);
    }
    else{
     $(".nav-main-logo, .nav-container, .nav-standard-float").css({"position":"relative", "background": bgColor, "width" : "100%"});
    }

     // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onReorder)) {
      instance.onReorder(evt);
    }

  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;
    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});


 theme.LibraryLoader = (function() {
  var types = {
    link: 'link',
    script: 'script'
  };

  var status = {
    requested: 'requested',
    loaded: 'loaded'
  };

  var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

  var libraries = {
    youtubeSdk: {
      tagId: 'youtube-sdk',
      src: 'https://www.youtube.com/iframe_api',
      type: types.script
    },
    plyrShopifyStyles: {
      tagId: 'plyr-shopify-styles',
      src: cloudCdn + 'shopify-plyr/v1.0/shopify-plyr.css',
      type: types.link
    },
    modelViewerUiStyles: {
      tagId: 'shopify-model-viewer-ui-styles',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
      type: types.link
    }
  };

  function load(libraryName, callback) {
    var library = libraries[libraryName];

    if (!library) return;
    if (library.status === status.requested) return;

    callback = callback || function() {};
    if (library.status === status.loaded) {
      callback();
      return;
    }

    library.status = status.requested;

    var tag;

    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }

    tag.id = library.tagId;
    library.element = tag;

    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement('script');
    tag.src = library.src;
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement('link');
    tag.href = library.src;
    tag.rel = 'stylesheet';
    tag.type = 'text/css';
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  return {
    load: load
  };
})();

theme.StoreAvailability = (function() {

  var selectors = {
    storeAvailabilityModalOpen: '[data-store-availability-modal-open]',
    storeAvailabilityModalProductTitle: '[data-store-availability-modal-product-title]',
    storeAvailabilityModalVariantTitle: '[data-store-availability-modal-variant-title]'
  };

  var classes = {
    hidden: 'hide'
  };

  function StoreAvailability(container) {
    this.container = container;
    this.productTitle = this.container.dataset.productTitle;
    this.hasOnlyDefaultVariant =
      this.container.dataset.hasOnlyDefaultVariant === 'true';
  }
  StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
    updateContent: function(variantId) {
      var variantSectionUrl =
        this.container.dataset.baseUrl +
        '/variants/' +
        variantId +
        '/?section_id=store-availability';
      var self = this;

      this.container.style.opacity = 0.5;

      fetch(variantSectionUrl)
        .then(function(response) {
          return response.text();
        })
        .then(function(storeAvailabilityHTML) {
          if (storeAvailabilityHTML.trim() === '') {
            return;
          }
          self.container.innerHTML = storeAvailabilityHTML;
          self.container.innerHTML = self.container.firstElementChild.innerHTML;
          self.container.style.opacity = 1;

          var $openPopupButton = $(selectors.storeAvailabilityModalOpen);

          $openPopupButton.magnificPopup({
            mainClass: 'mfp-move-from-right mfp-drawer',
            removalDelay: 1000,
            items: {
              src: '#StoreAvailabilityModal',
              type: 'inline'
            }
          });
          self._updateProductTitle();
          if (self.hasOnlyDefaultVariant) {
            self._hideVariantTitle();
          }
        });
    },
    _updateProductTitle: function() {
      var storeAvailabilityModalProductTitle = this.container.querySelector(
        selectors.storeAvailabilityModalProductTitle
      );
      console.log(this.productTitle);
      storeAvailabilityModalProductTitle.textContent = this.productTitle;
    },
    _hideVariantTitle: function() {
      var storeAvailabilityModalVariantTitle = this.container.querySelector(
        selectors.storeAvailabilityModalVariantTitle
      );
      storeAvailabilityModalVariantTitle.classList.add(classes.hidden);
    }
  });

  return StoreAvailability;
})();

theme.VideoSection = (function() {
  // console.log('video section');
  function isOnScreen($el) {
    var elementTop = $el.offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  }

  function VideoSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var videoId = this.videoId = $container.attr('data-video-id');
    var videoLink = this.videoLink = $container.attr('data-video-link');
    var $video = $('#video-' + sectionId);
    var $playBtn = $('#video-play-' + sectionId);
    var videoType = this.videoType = $container.attr('data-video-type');


    if($(window).width() > 992 && $video.length) {
      if(videoType == 'vimeo'){
        var options = {
          id: videoId,
          muted: true,
          autoplay: true,
          loop: true,
          autopause: false
        };
        var video01Player = new Vimeo.Player('iframe-'+sectionId, options);

        video01Player.on('loaded', function() {
          if($("#video-"+sectionId+" iframe").length){
            $("#video-"+sectionId)
            .prepend('<div class="vidcover"></div>');

            $(window).resize( function(){
              var theWidth = $(window).width();
              var theHeight = $(window).height();
              var newWidth = (theHeight*1.77777778);
              var newHeight = (theWidth/1.77777778);

              if ( (theWidth > 1280) && (newHeight > theHeight )) {
                $('#video-'+sectionId+' iframe').css({'width':theWidth, 'height':newHeight});
              }

              if ( (theHeight > 720) && (newWidth > theWidth )) {
                $('#video-'+sectionId+' iframe').css({'height':theHeight, 'width':newWidth});
              }

              $('#video-'+sectionId+' .vidcover').css({'height':theHeight, 'width':theWidth});
            }).resize();

            if(!isOnScreen($video)) {
              video01Player.pause();
            }
            $(window).on('scroll', function(){
                if(!isOnScreen($video)) {
                  console.log("Video "+ videoId +" stopped");
                  video01Player.pause();
                } else {
                  console.log("Video "+ videoId +" playing");
                  video01Player.play();
                }
            });

          }
        });

      }else{
      $video.YTPlayer({
          fitToBackground: true,
          videoId: videoId,
          playerVars: {
            modestbranding: 1,
            autoplay: 1,
            controls: 0,
            showinfo: 0,
            branding: 0,
            rel: 0,
            iv_load_policy: 3,
            autohide: 1,
            wmode: "transparent",
            frameborder: 0
          },
          callback: function(){
            var player = $video.data('ytPlayer').player;
            console.log("Video "+ videoId +" loaded");
            if(!isOnScreen($video)) {
              player.pauseVideo();
            }
            $(window).on('scroll', function(){
              if(!player.neverPlay) {
                if(!isOnScreen($video)) {
                  console.log("Video "+ videoId +" stopped");
                  player.pauseVideo();
                } else {
                  console.log("Video "+ videoId +" playing");
                  player.playVideo();
                }
              }
            });
          }
       });
      }
    }else{
      $("#vimeo_iframe_wrapper-"+sectionId).remove();
    }

    function playerStop() {
      if($video.data('ytPlayer')) {
        var player = $video.data('ytPlayer').player;
        $video.hide();
        player.pauseVideo();
        player.neverPlay = true;
      }else{
         $video.hide();
      }
    }

    $playBtn.on('click', function(e){
      e.preventDefault();
      $.magnificPopup.open({
        items: {
          src: videoLink,
          type: 'iframe'
        },
        callbacks: {
          open: playerStop,
          close: playerStop
        }
      })
    });


  }

  return VideoSection;
})();


/*********************************************************************
*  #### Twitter Post Fetcher v17.0.2 ####
*  Coded by Jason Mayes 2015. A present to all the developers out there.
*  www.jasonmayes.com
*  Please keep this disclaimer with my code if you use it. Thanks. :-)
*  Got feedback or questions, ask here:
*  http://www.jasonmayes.com/projects/twitterApi/
*  Github: https://github.com/jasonmayes/Twitter-Post-Fetcher
*  Updates will be posted to this site.
*********************************************************************/
(function(root,factory){if(typeof define==='function'&&define.amd){define([],factory);}else if(typeof exports==='object'){module.exports=factory();}else{factory();}}(this,function(){var domNode='';var maxTweets=20;var parseLinks=true;var queue=[];var inProgress=false;var printTime=true;var printUser=true;var formatterFunction=null;var supportsClassName=true;var showRts=true;var customCallbackFunction=null;var showInteractionLinks=true;var showImages=false;var useEmoji=false;var targetBlank=true;var lang='en';var permalinks=true;var dataOnly=false;var script=null;var scriptAdded=false;function handleTweets(tweets){if(customCallbackFunction===null){var x=tweets.length;var n=0;var element=document.getElementById(domNode);var html='<ul>';while(n<x){html+='<li>'+tweets[n]+'';n++;}
html+='</x){html+='<li></ul>';element.innerHTML=html;}else{customCallbackFunction(tweets);}}
function strip(data){return data.replace(/<b[^>]*>(.*?)<\/b>/gi,function(a,s){return s;}).replace(/class="(?!(tco-hidden|tco-display|tco-ellipsis))+.*?"|data-query-source=".*?"|dir=".*?"|rel=".*?"/gi,'');}
function targetLinksToNewWindow(el){var links=el.getElementsByTagName('a');for(var i=links.length-1;i>=0;i--){links[i].setAttribute('target','_blank');}}
function getElementsByClassName(node,classname){var a=[];var regex=new RegExp('(^| )'+classname+'( |$)');var elems=node.getElementsByTagName('*');for(var i=0,j=elems.length;i<j;i++){if(regex.test(elems[i].classname)){a.push(elems[i]);}} return="" a;}="" function="" extractAuthor(el)="" {="" var="" $el="$(el);" link="$el.find('a').attr('href');" link;="" }="" extractImageUrl(image_data){if(image_data!="=undefined&&image_data.innerHTML.indexOf('data-srcset')">=0){var data_src=image_data.innerHTML.match(/data-srcset="([A-z0-9%_\.-]+)/i)[0];return decodeURIComponent(data_src).split('"')[1];}}
var twitterFetcher={fetch:function(config){if(config.maxTweets===undefined){config.maxTweets=20;}
if(config.enableLinks===undefined){config.enableLinks=true;}
if(config.showUser===undefined){config.showUser=true;}
if(config.showTime===undefined){config.showTime=true;}
if(config.dateFunction===undefined){config.dateFunction='default';}
if(config.showRetweet===undefined){config.showRetweet=true;}
if(config.customCallback===undefined){config.customCallback=null;}
if(config.showInteraction===undefined){config.showInteraction=true;}
if(config.showImages===undefined){config.showImages=false;}
if(config.useEmoji===undefined){config.useEmoji=false;}
if(config.linksInNewWindow===undefined){config.linksInNewWindow=true;}
if(config.showPermalinks===undefined){config.showPermalinks=true;}
if(config.dataOnly===undefined){config.dataOnly=false;}
if(inProgress){queue.push(config);}else{inProgress=true;domNode=config.domId;maxTweets=config.maxTweets;parseLinks=config.enableLinks;printUser=config.showUser;printTime=config.showTime;showRts=config.showRetweet;formatterFunction=config.dateFunction;customCallbackFunction=config.customCallback;showInteractionLinks=config.showInteraction;showImages=config.showImages;useEmoji=config.useEmoji;targetBlank=config.linksInNewWindow;permalinks=config.showPermalinks;dataOnly=config.dataOnly;var head=document.getElementsByTagName('head')[0];if(script!==null){head.removeChild(script);}
script=document.createElement('script');script.type='text/javascript';if(config.list!==undefined){script.src='https://syndication.twitter.com/timeline/list?'+'callback=__twttrf.callback&dnt=false&list_slug='+
config.list.listSlug+'&screen_name='+config.list.screenName+'&suppress_response_codes=true&lang='+(config.lang||lang)+'&rnd='+Math.random();}else if(config.profile!==undefined){script.src='https://syndication.twitter.com/timeline/profile?'+'callback=__twttrf.callback&dnt=false'+'&screen_name='+config.profile.screenName+'&suppress_response_codes=true&lang='+(config.lang||lang)+'&rnd='+Math.random();}else if(config.likes!==undefined){script.src='https://syndication.twitter.com/timeline/likes?'+'callback=__twttrf.callback&dnt=false'+'&screen_name='+config.likes.screenName+'&suppress_response_codes=true&lang='+(config.lang||lang)+'&rnd='+Math.random();}else{script.src='https://cdn.syndication.twimg.com/widgets/timelines/'+
config.id+'?&lang='+(config.lang||lang)+'&callback=__twttrf.callback&'+'suppress_response_codes=true&rnd='+Math.random();}
head.appendChild(script);}},callback:function(data){if(data===undefined||data.body===undefined){inProgress=false;if(queue.length>0){twitterFetcher.fetch(queue[0]);queue.splice(0,1);}
return;}
if(!useEmoji){data.body=data.body.replace(/(<img[^c]*class="emoji[^>]*>)|(<img[^c]*class="u-block[^>]*>)/g,'');}
if(!showImages){data.body=data.body.replace(/(<img[^c]*class="naturalimage-image[^>]*>|(<img[^c]*class="croppedimage-image[^>]*>))/g,'');}
if(!printUser){data.body=data.body.replace(/(<img[^c]*class="avatar"[^>]*>)/g,'');}
var div=document.createElement('div');div.innerHTML=data.body;if(typeof(div.getElementsByClassName)==='undefined'){supportsClassName=false;}
function swapDataSrc(element){var avatarImg=element.getElementsByTagName('img')[0];avatarImg.src=avatarImg.getAttribute('data-src-2x');return element;}
var tweets=[];var authors=[];var times=[];var images=[];var rts=[];var tids=[];var permalinksURL=[];var x=0;if(supportsClassName){var tmp=div.getElementsByClassName('timeline-Tweet');while(x<tmp.length){if(tmp[x].getelementsbyclassname('timeline-tweet-retweetcredit').length>0){rts.push(true);}else{rts.push(false);}
if(!rts[x]||rts[x]&&showRts){tweets.push(tmp[x].getElementsByClassName('timeline-Tweet-text')[0]);tids.push(tmp[x].getAttribute('data-tweet-id'));if(printUser){authors.push(swapDataSrc(tmp[x].getElementsByClassName('timeline-Tweet-author')[0]));}
times.push(tmp[x].getElementsByClassName('dt-updated')[0]);permalinksURL.push(tmp[x].getElementsByClassName('timeline-Tweet-timestamp')[0]);if(tmp[x].getElementsByClassName('timeline-Tweet-media')[0]!==undefined){images.push(tmp[x].getElementsByClassName('timeline-Tweet-media')[0]);}else{images.push(undefined);}}
x++;}}else{var tmp=getElementsByClassName(div,'timeline-Tweet');while(x<tmp.length){if(getelementsbyclassname(tmp[x],'timeline-tweet-retweetcredit').length>0){rts.push(true);}else{rts.push(false);}
if(!rts[x]||rts[x]&&showRts){tweets.push(getElementsByClassName(tmp[x],'timeline-Tweet-text')[0]);tids.push(tmp[x].getAttribute('data-tweet-id'));if(printUser){authors.push(swapDataSrc(getElementsByClassName(tmp[x],'timeline-Tweet-author')[0]));}
times.push(getElementsByClassName(tmp[x],'dt-updated')[0]);permalinksURL.push(getElementsByClassName(tmp[x],'timeline-Tweet-timestamp')[0]);if(getElementsByClassName(tmp[x],'timeline-Tweet-media')[0]!==undefined){images.push(getElementsByClassName(tmp[x],'timeline-Tweet-media')[0]);}else{images.push(undefined);}}
x++;}}
if(tweets.length>maxTweets){tweets.splice(maxTweets,(tweets.length-maxTweets));authors.splice(maxTweets,(authors.length-maxTweets));times.splice(maxTweets,(times.length-maxTweets));rts.splice(maxTweets,(rts.length-maxTweets));images.splice(maxTweets,(images.length-maxTweets));permalinksURL.splice(maxTweets,(permalinksURL.length-maxTweets));}
var arrayTweets=[];var x=tweets.length;var n=0;if(dataOnly){while(n<x){arraytweets.push({tweet:tweets[n].innerhtml,author:authors[n]?authors[n].innerhtml:'unknown Author',author_data:{profile_url:authors[n]?authors[n].querySelector('[data-scribe="element:user_link" ]').href:null,profile_image:authors[n]?authors[n].querySelector('[data-scribe="element:avatar" ]').getAttribute('data-src-1x'):null,profile_image_2x:authors[n]?authors[n].querySelector('[data-scribe="element:avatar" ]').getAttribute('data-src-2x'):null,screen_name:authors[n]?authors[n].querySelector('[data-scribe="element:screen_name" ]').title:null,name:authors[n]?authors[n].querySelector('[data-scribe="element:name" ]').title:null},time:times[n].textContent,timestamp:times[n].getAttribute('datetime').replace('+0000','Z').replace(="" ([\+\-])(\d\d)(\d\d)="" ,'$1$2:$3'),image:extractImageUrl(images[n]),rt:rts[n],tid:tids[n],permalinkURL:(permalinksURL[n]="==undefined)?'':permalinksURL[n].href});n++;}}else{while(n<x){if(typeof(formatterFunction)!=='string'){var" datetimeText="times[n].getAttribute('datetime');var" newDate="new" Date(times[n].getAttribute('datetime').replace(="" -="" g,'="" ').replace('T','="" ').split('+')[0]);var="" dateString="formatterFunction(newDate,datetimeText);times[n].setAttribute('aria-label',dateString);if(tweets[n].textContent){if(supportsClassName){times[n].textContent=dateString;}else{var" h="document.createElement('p');var" t="document.createTextNode(dateString);h.appendChild(t);h.setAttribute('aria-label',dateString);times[n]=h;}}else{times[n].textContent=dateString;}}" var="" op="" ;if(parseLinks){if(targetBlank){targetLinksToNewWindow(tweets[n]);if(printUser){targetLinksToNewWindow(authors[n]);}}="" if(printUser){op+="<div class=&quot;swiper-slide&quot;><div class=&quot;tweet-wrapper&quot;><div class=&quot;user&quot;>" +strip(authors[n].innerHTML)+'<="" div="">';}
op+='<p class="tweet">'+strip(tweets[n].innerHTML)+'</p>';if(printTime){if(permalinks){op+='<p class="timePosted"><a href="'+permalinksURL[n]+'">'+times[n].getAttribute('aria-label')+'</a></p>';}else{op+='<p class="timePosted">'+
times[n].getAttribute('aria-label')+'</p>';}}}else{if(tweets[n].textContent){if(printUser){op+='<p class="user">'+authors[n].textContent+'</p>';}
op+='<p class="tweet">'+tweets[n].textContent+'</p>';if(printTime){op+='<p class="timePosted">'+times[n].textContent+'</p>';}}else{if(printUser){op+='<p class="user">'+authors[n].textContent+'</p>';}
op+='<p class="tweet">'+tweets[n].textContent+'</p>';if(printTime){op+='<p class="timePosted">'+times[n].textContent+'</p>';}}}
if(showInteractionLinks){op+='<p class="interact"><a href="https://twitter.com/intent/'+'tweet?in_reply_to='+tids[n]+'" class="twitter_reply_icon" '+="" (targetBlank?'="" target="_blank">':'>')+'</a><a href="https://twitter.com/intent/retweet?'+'tweet_id='+tids[n]+'" class="twitter_retweet_icon" '+="" (targetBlank?'="" target="_blank">':'>')+'</a>'+'<a href="https://twitter.com/intent/favorite?tweet_id='+
tids[n]+'" class="twitter_fav_icon" '+="" (targetBlank?'="" target="_blank">':'>')+'</a></p></x){arraytweets.push({tweet:tweets[n].innerhtml,author:authors[n]?authors[n].innerhtml:'unknown></tmp.length){if(getelementsbyclassname(tmp[x],'timeline-tweet-retweetcredit').length></tmp.length){if(tmp[x].getelementsbyclassname('timeline-tweet-retweetcredit').length></img[^c]*class="avatar"[^></img[^c]*class="croppedimage-image[^></img[^c]*class="naturalimage-image[^></img[^c]*class="u-block[^></img[^c]*class="emoji[^></j;i++){if(regex.test(elems[i].classname)){a.push(elems[i]);}}></b[^></r?(n=math.ceil(r*o.options.ratio),d.width(n).height(r).css({left:(l-n)></t.length;n++){var>